import ajax from '../utils/request';

const systemMessageApi = {
  /********************************系统管理*********************************** */
  // 获取消息通知列表
  getSystemMessage(params) {
    return ajax({
      url: '/infmt/notice/list',
      type: 'get',
      params: params
    });
  },
  // 删除消息通知
  removeMessage(params) {
    return ajax({
      url: '/infmt/notice/delete',
      type: 'delete',
      params: params
    });
  },
  addMessage(params) {
    return ajax({
      url: '/infmt/notice/add',
      type: 'post',
      params: params
    });
  },
  // 编辑通知
  editMessage(params) {
    return ajax({
      url: '/infmt/notice/update',
      type: 'post',
      params: params
    });
  },
  // 获取邮件列表
  getEmailList(params) {
    return ajax({
      url: '/infmt/mail/list',
      type: 'get',
      params: params
    });
  },
  // 添加邮件
  addEmail(params) {
    return ajax({
      url: '/infmt/mail/add',
      type: 'post',
      params: params
    });
  },
  // 删除邮件
  removeEmail(params) {
    return ajax({
      url: '/infmt/mail/delete',
      type: 'delete',
      params: params
    });
  }
};
export default systemMessageApi;
